/* * @Author: 孙福聪 * @Date: 2019-01-16 16:02:35 * @Last Modified by: 孙福聪 * @Last Modified time:
2019-03-26 15:21:52 */
<template lang="pug">
div.classlist
    div
        Table(:columns="columns1" :data="classList" width="1180px")
        Button(type="primary" @click="modal1 = true") + 新建
        a(href="./static/students.xls")
          Button.large(type="primary") 下载学生模版
        Page.page(@on-change="handleCurrentChange" :total="pageData.totalRecords"
         :page-size="10" show-elevator show-total)
         span 当前有{{classList.length}}条数据,共{{pageData.totalRecords?pageData.totalRecords:0}}条数据
    Modal(v-model="modal1" title="创建班级" width="30")
      Form.form(ref='classForm' :model='classForm',
      :label-width='95',label-position='left',:rules="formRules" v-if="modal1")
          FormItem(prop='name',label='班级名称：')
            Input(v-model='classForm.name' placeholder='请输入班级名称' :maxlength="20")
          FormItem(prop='remarks', label='班级描述：')
            Input(v-model='classForm.remarks' placeholder='请填写内容'
               type="textarea" :rows="3")
          FormItem(prop='teacherCode',label='任课教师：',v-if="role==='admin'")
            Select(v-model="classForm.teacherCode" style="width:200px")
              Option(v-for='(v, index) in allTeacherList', :key="index",
                :disabled="v.code==='admin'"
                :value="v.code",:label='v.name')
          FormItem(prop='teacherCode',label='任课教师：',v-if="role==='teacher'")
            Select(v-model="classForm.teacherCode" style="width:200px")
              Option(:label="username",:value="usercode") {{username}}
      div(slot="footer")
        <Button @click='modal1 = false'>取消</Button>
        <Button type="primary" @click="createClass('classForm')">确定</Button>
    Modal(v-model="modal2" title="编辑班级" width="30")
      Form.form(ref='editorclassForm' :model='editorclassForm',
      :label-width='95',label-position='left',:rules="formRules" v-if="modal2")
          FormItem(prop='name',label='班级名称：')
            Input(v-model='editorclassForm.name' placeholder='请输入班级名称' :maxlength="20")
          FormItem(prop='remarks', label='班级描述：')
            Input(v-model='editorclassForm.remarks' placeholder='请填写内容'
               type="textarea" :rows="3")
          FormItem(prop='teacherCode',label='任课教师：',v-if="role==='admin'")
            Select(v-model="editorclassForm.teacherCode" style="width:200px")
              Option(v-for='(v, index) in allTeacherList', :key="index",
                :disabled="v.code==='admin'"
                :value="v.code",:label='v.name')
      div(slot="footer")
        <Button @click='modal2 = false'>取消</Button>
        <Button type="primary" @click="editorClass('editorclassForm')">确定</Button>
    Modal(v-model="modal3" title="学生明细" width="800" @on-ok="")
      Table(:columns="columns2" :data="studentList")
      Button.modal4btn(type="primary",
        @click="modal4 = true",
        style="margin-top:28px;width:88px;position:absolute") 创建
    Modal(v-model="modal4" title="添加学生" width="416")
      Form.form(ref='addStudent' :model='addStudent',:rules="formRules2",
      :label-width='70',label-position='left' v-if="modal4")
          FormItem(prop='code',label='账号：')
            Input(v-model='addStudent.code' placeholder='请输入账号' :maxlength="20")
          FormItem(prop='name', label='姓名：')
            Input(v-model='addStudent.name' placeholder='请输入姓名' :maxlength="20")
          FormItem(label='密码：')
            span.span1 初始密码为{{newPassword}}
      div(slot="footer")
        <Button @click='modal4 = false'>取消</Button>
        <Button type="primary" @click="createStudent('addStudent')">确定</Button>
    Modal(v-model="modal5" title="编辑学生信息" width="416")
      Form.form(ref='editorStudentForm' :model='editorStudentForm',:rules="formRules2",
      :label-width='70',label-position='left')
          FormItem(prop='classCode',label='班级：')
            Select(v-model="editorStudentForm.classCode" style="width:200px")
              Option(v-for='(v, index) in classList1', :key="index", disabled,
                :value="v.id",:label='v.name')
          FormItem(prop='code' label='账号：')
            Input(v-model='editorStudentForm.code' placeholder='请输入账号' disabled)
          FormItem(prop='name', label='姓名：')
            Input(v-model='editorStudentForm.name' placeholder='请输入姓名' :maxlength="20")
          FormItem(label='密码：')
            div.resetpassword(@click="resetPassword",style="color:#2789F0;cursor:pointer") 重置密码
            span.span1 初始密码为{{newPassword}}
      div(slot="footer")
        <Button @click='modal5 = false'>取消</Button>
        <Button type="primary" @click="editorStudent('editorStudentForm')">确定</Button>
</template>

<script>
export default {
  data() {
    return {
      newPassword: "",
      role: this.$role.role,
      username: this.$role.name,
      usercode: this.$role.code,
      studentid: "",
      pageData: {}, // 表格分页数据
      page: 1,
      editorStudentForm: {
        code: "",
        name: ""
      },
      addStudent: {
        // 模态框1数据
        code: "",
        name: "",
        id: ""
      },
      allTeacherList: [],
      teacherlist: [],
      classList: [], // 班级列表
      classList1: [], // 班级列表
      studentList: [], // 学生列表
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      modal5: false,
      loadingNum: 0,
      formRules2: {
        code: [
          { required: true, message: "请输入学生账号", trigger: "change" },
          {
            pattern: /^[a-zA-Z0-9_-]{1,20}$/,
            message: "账号只能为字母,下划线数字,长度不能超过20位",
            trigger: "blur"
          }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "change" },
          {
            // pattern: /^.{2,20}$/,
            // message: "姓名只能是2-20位",
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
            message: "姓名只能是数字,字母,汉字组成,不能包含特殊符号和空格,长度2-20位",
            trigger: "blur"
          }
        ]
      },
      formRules: {
        // 表单正则
        name: [
          { required: true, message: "请输入班级名称", trigger: "change" },
          {
            // pattern: /^.{2,20}$/,
            // message: "班级名称只能是2-20位",
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
            message: "不能包含特殊符号和空格,长度2-20位",
            trigger: "blur"
          }
        ],
        remarks: [
          { required: true, message: "请输入内容", trigger: "change" },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
            message: "不能包含特殊符号和空格",
            trigger: "blur"
          }
        ],
        teacherCode: [
          { required: true, message: "请选择教师", trigger: "blur" },
          {
            trigger: "change"
          }
        ]
      },
      classForm: {
        name: "",
        remarks: "",
        teacherCode: ""
      },
      editorclassForm: {
        name: "",
        remarks: "",
        teacherCode: "",
        id: ""
      },
      columns2: [
        {
          title: "序号",
          type: "index"
        },
        {
          title: "账号",
          key: "code"
        },
        {
          title: "姓名",
          key: "name"
        },
        {
          title: "删除",
          render: (h, params) => {
            return h("div", [
              h("i", {
                class: "icon-shanchu iconfont",
                fixed: "center",
                style: "font-size:20px",
                on: {
                  click: () => {
                    this.confirmstudent(params.row);
                  }
                }
              })
            ]);
          }
        },
        {
          title: "编辑",
          render: (h, params) => {
            return h("div", [
              h("i", {
                class: "icon-bianji iconfont",
                fixed: "center",
                style: "font-size:20px",
                on: {
                  click: () => {
                    //
                    this.show2(params.row);
                  }
                }
              })
            ]);
          }
        }
      ],
      columns1: [
        // {
        //   title: "序号",
        //   type: "index"
        // },
        {
          title: "班级名称",
          key: "name",
          width: 264,
          tooltip: true
        },
        {
          title: "班级人数",
          key: "stuNum",
          width: 100,
          align: "center"
        },
        {
          title: "所属教师",
          key: "teacherName",
          width: 100,
          tooltip: true
        },
        {
          title: "学生明细",
          // width: 90,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  class: "iconfont",
                  fixed: "center",
                  style: "font-size:14px;color: #3A76D2;margin-left:14px",
                  on: {
                    click: () => {
                      this.stushow(params.row);
                      this.modal4show(params.row);
                      this.modal4 = false;
                    }
                  }
                },
                "查看"
              )
            ]);
          }
        },
        // {
        //   title: "删除",
        //   render: (h, params) => {
        //     return h("div", [
        //       h("i", {
        //         class: "icon-shanchu iconfont",
        //         fixed: "center",
        //         style: "font-size:20px",
        //         on: {
        //           click: () => {
        //             this.confirm(params.row);
        //           }
        //         }
        //       }),
        //       h(
        //         "span",
        //         {
        //           style: {
        //             color: "#4A90E2",
        //             fontSize: "14px",
        //             lineHeight: "40px",
        //             cursor: "pointer"
        //           },
        //           on: {
        //             click: () => {
        //               this.confirm(params.row);
        //             }
        //           }
        //         },
        //         "删除"
        //       )
        //     ]);
        //   }
        // },
        // {
        //   title: "编辑",
        //   render: (h, params) => {
        //     return h("div", [
        //       h("i", {
        //         class: "icon-bianji iconfont",
        //         fixed: "center",
        //         style: "font-size:20px",
        //         on: {
        //           click: () => {
        //             this.show(params.row);
        //           }
        //         }
        //       }),
        //       h(
        //         "span",
        //         {
        //           style: {
        //             color: "#4A90E2",
        //             fontSize: "14px",
        //             lineHeight: "40px",
        //             cursor: "pointer"
        //           },
        //           on: {
        //             click: () => {
        //               this.show(params.row);
        //             }
        //           }
        //         },
        //         "编辑"
        //       )
        //     ]);
        //   }
        // },
        {
          title: "操作",
          width: 226,
          // fixed: "right",
          render: (h, params) => {
            return h("div", [
              h("i", {
                class: "icon-bianji4 iconfont",
                fixed: "center",
                style: "color:#3A76D2",
                on: {
                  click: () => {
                    this.show(params.row);
                  }
                }
              }),
              h(
                "span",
                {
                  style: {
                    color: "#3A76D2",
                    fontSize: "14px",
                    lineHeight: "40px",
                    cursor: "pointer"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#DCDCDC",
                    padding: "0 6px"
                  }
                },
                "|"
              ),
              h(
                "Upload",
                {
                  class: "icon-daoru2 iconfont",
                  style: "font-size:14px;color:#3A76D2",
                  props: {
                    action: "./classMember/insertStudent",
                    headers: { token: sessionStorage.getItem("tokenTest") },
                    data: {
                      classId: params.row.id
                    },
                    beforeUpload: () => {
                      this.loadingNum = 0;
                      this.$Message.loading({
                        render: h1 => {
                          return h1("div", {}, [
                            h1(
                              "Progress",
                              {
                                style: "width: 220px;",
                                props: {
                                  percent: this.loadingNum,
                                  status: "active"
                                }
                              },
                              ""
                            ),
                            h1("div", {}, `正在上传 ${this.loadingNum}%`)
                          ]);
                        },
                        duration: 0
                      });
                    },
                    onProgress: ev => {
                      // eslint-disable-next-line radix
                      this.loadingNum = parseInt((ev.loaded / ev.total) * 100);
                    },
                    onSuccess: response => {
                      if (response.success) {
                        this.$Message.destroy();
                        this.$Message.success("导入成功");
                        this.loadingNum = 0;
                        //
                        this.listClassRequest();
                      } else {
                        this.$Message.destroy();
                        this.$Message.error(response.message);
                        this.loadingNum = 0;
                      }
                    },
                    onError: () => {
                      this.$Message.destroy();
                      this.$Message.error("导入学生失败");
                      this.loadingNum = 0;
                    }
                  }
                },
                ""
              ),
              h(
                "span",
                {
                  style: {
                    color: "#3A76D2",
                    fontSize: "14px",
                    lineHeight: "40px",
                    cursor: "pointer"
                  },
                  props: {
                    action: "./classMember/insertStudent",
                    data: {
                      classId: params.row.id
                    },
                    onSuccess: response => {
                      if (response.success) {
                        this.$Message.success("导入成功");
                        //
                        this.listClassRequest();
                      } else {
                        this.$Message.error(response.message);
                      }
                    },
                    onError: () => {
                      this.$Message.error("导入学生失败");
                    }
                  }
                },
                "导入"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#DCDCDC",
                    padding: "0 6px"
                  }
                },
                "|"
              ),
              h("i", {
                class: "icon-shanchulaji iconfont",
                fixed: "center",
                style: "color:#3A76D2",
                on: {
                  click: () => {
                    this.confirm(params.row);
                  }
                }
              }),
              h(
                "span",
                {
                  style: {
                    color: "#3A76D2",
                    fontSize: "14px",
                    lineHeight: "40px",
                    cursor: "pointer"
                  },
                  on: {
                    click: () => {
                      this.confirm(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  methods: {
    resetpass() {
      // 重置密码功能
      const data = {
        code: this.editorStudentForm.code,
        newPassword: this.newPassword
      };
      this.$http.resetPassword(data).then(res => {
        if (res.data.success) {
          this.$Message.success("重置密码成功");
        } else {
          this.$Message.error("重置密码失败");
        }
      });
    },
    resetPassword() {
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "系统提示",
        content: `<p>你确定要把该用户的密码重置为${this.newPassword}吗?</p>`,
        onOk: () => {
          this.resetpass();
        }
      });
    },
    editorStudent(formName) {
      // 编辑学生用户
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = {
            code: this.editorStudentForm.code,
            name: this.editorStudentForm.name
          };
          this.$http.editorStudent(data).then(res => {
            if (res.data.success) {
              this.modal5 = false;
              this.$Message.success("修改成功");
              this.requeststudentlist();
            }
          });
        } else {
          this.$Message.error("请填写");
          return false;
        }
      });
    },
    show2(row) {
      // 弹出编辑学生模态框并拿到当前数据
      this.editorStudentForm = {
        code: row.code,
        name: row.name,
        classCode: row.classId
      };
      this.modal5 = true;
    },
    modal4show(row) {
      console.log("row: ", row);
      // 弹出编辑学生模态框
      this.modal4 = true;
      this.addStudent.id = row.id;
    },
    createStudent(formName) {
      // 创建学生用户
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = {
            // classId: this.addStudent.id,
            name: this.addStudent.name,
            code: this.addStudent.code,
            isTeacher: false
          };
          this.$http.createUser(data).then(res => {
            if (res.data.success) {
              this.modal4 = false;
              const data1 = {
                classId: this.addStudent.id,
                userId: this.addStudent.code
              };
              this.$http.createclassStudent(data1).then(res1 => {
                if (res1.data.success) {
                  this.$Message.success("创建学生成功");
                  this.requeststudentlist();
                  this.listClassRequest();
                  this.addStudent = {
                    code: "",
                    name: "",
                    id: this.addStudent.id
                  };
                  this.$forceUpdate();
                } else {
                  this.$Message.error("创建学生失败");
                }
              });
            }
          });
        } else {
          this.$Message.error("请填写");
          return false;
        }
      });
    },
    confirmstudent(row) {
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "是否确定删除该学生",
        content: "<p>删除该学生会将其数据一并删除。</p>",
        onOk: () => {
          this.deletstudent(row);
        }
      });
    },
    deletstudent(row) {
      // 删除学生用户
      const data = {
        classRoom_uuid: row.classId,
        userId: row.code
      };
      this.$http.deleteStudent(data).then(res => {
        if (res.data.success) {
          this.$Message.success("删除成功");
          this.requeststudentlist();
          this.listClassRequest();
        } else {
          this.$Message.error("删除失败");
        }
      });
    },
    stushow(row) {
      // 弹出学生明细模态框
      this.studentid = row.id;
      this.requeststudentlist();
    },
    requeststudentlist() {
      const data = {
        classRoom_uuid: this.studentid
      };
      console.log(this.studentid);
      this.$http.listClassMemberRequest(data).then(res => {
        if (res.data.success) {
          this.studentList = res.data.data.list;
          this.modal3 = true;
        }
      });
    },
    editorClass(formName) {
      // 编辑班级
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = {
            name: this.editorclassForm.name,
            remarks: this.editorclassForm.remarks,
            uuid: this.editorclassForm.id,
            teacherCode: this.editorclassForm.teacherCode
          };
          this.$http.createClass(data).then(res => {
            if (res.data.success) {
              this.modal2 = false;
              this.$Message.success("修改成功");
              this.listClassRequest();
            }
          });
        } else {
          this.$Message.error("请填写");
          return false;
        }
      });
    },
    show(row) {
      // 编辑显示模态框2
      this.editorclassForm = {
        name: row.name,
        id: row.id,
        remarks: row.remarks,
        teacherCode: row.teacherCode
      };
      this.modal2 = true;
    },
    deletClass(row) {
      // 删除班级列表数据
      const data = {
        ids: []
      };
      data.ids.push(row.id);
      data.ids = JSON.stringify(data.ids);

      this.$http.deleteClass(data).then(res => {
        if (res.data.success) {
          this.listClassRequest();
        }
      });
    },
    confirm(row) {
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "是否确定删除班级?",
        content: "<p>删除该班级会将其数据一并删除</p>",
        onOk: () => {
          this.deletClass(row);
        }
      });
    },
    handleCurrentChange(page) {
      // 分页函数
      this.page = page;
      this.listClassRequest(page);
    },
    createClass(formName) {
      // 创建班级
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = {
            name: this.classForm.name,
            remarks: this.classForm.remarks,
            teacherCode: this.classForm.teacherCode
          };
          this.$http.createClass(data).then(res => {
            if (res.data.success) {
              this.modal1 = false;
              this.$Message.success("创建成功");
              this.listClassRequest();
              this.classForm = {
                name: "",
                remarks: "",
                teacherCode: ""
              };
              this.$forceUpdate();
            }
          });
        } else {
          this.$Message.error("请填写完整");
          return false;
        }
      });
    },
    listClassRequest(page) {
      const pageNo = page || 1;
      // 获取班级id
      const data1 = {
        teacherCode: this.$role.code,
        pageNo,
        pageSize: 10
      };
      if (this.$role.code === "admin") {
        delete data1.teacherCode;
      }
      this.$http.listClassRequest(data1).then(res => {
        console.log(res);
        console.log(this);
        if (res.data.success) {
          this.getTeacherlist();
          if (res.data.data.list.length > 0) {
            this.listclass = res.data.data.list[0].id;
            this.className = res.data.data.list[0].name;
            this.classList1 = res.data.data.list;
            this.classList = res.data.data.list;
            this.classList1.forEach((e, index) => {
              if (e.vipClass) {
                this.classList1.splice(index, 1);
              }
            });
            this.classList.forEach((e, index) => {
              if (e.vipClass) {
                this.classList.splice(index, 1);
              }
            });
            this.pageData = res.data.data;
          } else {
            this.classList = [];
          }
        }
      });
    },
    getAllTeacherList() {
      this.$http.listUser({}).then(res => {
        if (res.data.success) {
          this.allTeacherList = res.data.data.list;
        }
      });
    },
    getTeacherlist() {
      // 查询教师列表 供添加修改学生功能使用
      const data = {
        classRoom_uuid: this.listclass,
        pageNo: this.page,
        pageSize: 10
      };
      console.log(this.listclass);
      this.$http
        .listUser({ classRoom_uuid: data.id, pageNo: this.page, pageSize: 10 })
        .then(res => {
          if (res.data.success) {
            this.teacherlist = res.data.data.list;
          }
        });
    }
  },
  watch: {
    modal1() {
      if (!this.modal1) {
        this.classForm = {
        name: "",
        remarks: "",
        teacherCode: ""
        };
      }
    },
    modal4() {
      if (!this.modal4) {
        // this.addStudent = {
        //   code: "",
        //   name: "",
        //   id: ""
        // };
        this.addStudent.code = "";
        this.addStudent.name = "";
      }
    }
  },
  async created() {
    const { data } = await this.$http.getDefaultPassword();
    this.newPassword = data.data;
    this.listClassRequest();
    this.getAllTeacherList();
  }
};
</script>

<style lang="stylus" scope>
.classlist
  overflow hidden
  .ivu-table-wrapper
    border-color #EEF2F5
    .ivu-table:after
      background #EEF2F5
      z-index -99
    .ivu-table:before
      background-color #EEF2F5
    .ivu-table
      background #EEF2F5
      padding-bottom 2px
      font-size 14px
      thead
        tr
          th
            background #eef2f5
            font-weight bolder
            color #000
      tbody
        tr
          td
            // text-align: center;
            border-top 1px solid transparent
            border-collapse unset
            box-sizing border-box
            height 40px
            &:first-child
              border-left 1px solid transparent
              border-radius 8px 0 0 8px
            &:last-child
              border-right 1px solid transparent
              border-radius 0 8px 8px 0
          &:last-child
            td
              border-bottom 1px solid transparent !important
  .ivu-table-tip
    tr
      td
        &:last-child
          border-radius 8px 8px 8px 8px !important
  .ivu-page-total
    span
      color #999999
      font-size 14px
  .ivu-page-item-active
    background #57A3F3
    a
      color #FFFFFF
  .ivu-upload-select
    width 40px
    height 18px
    position relative
    top -20px
  button
    height 32px
    margin-top 30px
    float left
  .large
    display block
    margin-left 16px
    width 126px
  .page
    margin-top 30px
    float right
  .ivu-input
    display block
    width 95%
    height 32px
  .ivu-modal-footer
    height 60px
  .ivu-btn-large
    margin-top -5px
    display block
    float right
  .span1
    font-size 14px
    color #808080
  .ivu-modal-confirm-body
    display block
    height 50px
    margin-top 10px
  .iconfont
    cursor pointer
  .icon-daoru2
    display inline-block
    margin 0 auto
    width 16px
    height 20px
    vertical-align middle
</style>
